export const isKeyInObject = <T extends Record<string | number | symbol, unknown>>(
  key: string | number | symbol,
  object: T,
): key is keyof T => key in object;

export const ObjectKeys = <T extends Record<string, unknown>>(obj: T) =>
  Object.keys(obj) as (keyof T)[];

export const isNullOrUndefined = <T>(value: T | undefined | null): value is null | undefined =>
  value === undefined || value === null;

export const isNotNullNorUndefined = <T>(value: T | undefined | null): value is T =>
  !isNullOrUndefined(value);

export const orderByKey = <T>(elements: T[], key: keyof T): T[] => {
  const copyElements = [...elements];

  return copyElements
    .filter(element => typeof element[key] == 'number')
    .sort((elem1: T, elem2: T): number => Number(elem1[key]) - Number(elem2[key]));
};
